<o2-sheet side="right" maxWidth="37.5rem">
  <div o2SheetHeader>
    <h2 o2SheetTitle>{{ sheetTitle() }}</h2>
  </div>

  <div o2SheetBody>
    <o2-accordion-group [resetOnParentOpen]="sheetRef().isOpen()">
      <!-- Info Profilo Accordion -->
      <o2-accordion-item label="Info profilo">
        <div class="p-5 pt-2">
          <form [formGroup]="profileForm" class="flex flex-col gap-3.5">
            <!-- Nome -->
            <div class="flex items-start gap-4">
              <label hlmLabel for="name" class="w-1/4 sheet-label pt-2"
                >Nome</label
              >
              <hlm-form-field class="w-3/4">
                <input
                  hlmInput
                  id="name"
                  type="text"
                  formControlName="name"
                  placeholder="Nome"
                />
                <hlm-error
                  >Il nome è obbligatorio (minimo 2 caratteri)</hlm-error
                >
              </hlm-form-field>
            </div>

            <!-- Cognome -->
            <div class="flex items-start gap-4">
              <label hlmLabel for="surname" class="w-1/4 sheet-label pt-2"
                >Cognome</label
              >
              <hlm-form-field class="w-3/4">
                <input
                  hlmInput
                  id="surname"
                  type="text"
                  formControlName="surname"
                  placeholder="Cognome"
                />
                <hlm-error
                  >Il cognome è obbligatorio (minimo 2 caratteri)</hlm-error
                >
              </hlm-form-field>
            </div>

            <!-- Telefono -->
            <div class="flex items-start gap-4">
              <label hlmLabel for="phone" class="w-1/4 sheet-label pt-2"
                >Telefono</label
              >
              <hlm-form-field class="w-3/4">
                <input
                  hlmInput
                  id="phone"
                  type="tel"
                  formControlName="phone"
                  placeholder="Telefono"
                />
                <hlm-error
                  >Inserire un numero di telefono valido (8-20
                  caratteri)</hlm-error
                >
              </hlm-form-field>
            </div>

            <!-- Email (readonly) -->
            <div class="flex items-start gap-4">
              <label hlmLabel for="email" class="w-1/4 sheet-label pt-2"
                >Email</label
              >
              <hlm-form-field class="w-3/4">
                <input
                  hlmInput
                  id="email"
                  type="email"
                  formControlName="email"
                  placeholder="Email"
                />
              </hlm-form-field>
            </div>
          </form>
        </div>
      </o2-accordion-item>

      <!-- Tema Accordion -->
      <o2-accordion-item label="Tema">
        <div class="p-5 pt-2 flex flex-col gap-3.5">
          <!-- System vs Custom Switch -->
          <div class="flex items-center justify-between">
            <div class="flex flex-col gap-1">
              <label hlmLabel class="text-sm font-medium">Modalità tema</label>
              <p class="text-xs text-muted-foreground">
                Usa il tema del sistema o scegli manualmente
              </p>
            </div>
            <div class="flex items-center gap-2">
              <span class="text-sm text-muted-foreground">Sistema</span>
              <hlm-switch
                [checked]="isCustomTheme()"
                (checkedChange)="onThemeModeChange($event)"
                aria-label="Modalità tema personalizzato"
              />
              <span class="text-sm text-muted-foreground">Custom</span>
            </div>
          </div>

          <!-- Light vs Dark Switch (enabled only if custom) -->
          <div class="flex items-center justify-between">
            <div class="flex flex-col gap-1">
              <label hlmLabel class="text-sm font-medium">Tema</label>
              <p class="text-xs text-muted-foreground">
                @if (isCustomTheme()) {
                  Scegli tra tema chiaro e scuro
                } @else {
                  Segue automaticamente il tema di sistema
                }
              </p>
            </div>
            <div class="flex items-center gap-2">
              <span
                class="text-sm"
                [class.text-muted-foreground]="!isCustomTheme()"
                [class.text-foreground]="isCustomTheme()"
              >
                Light
              </span>
              <hlm-switch
                [checked]="isDarkMode()"
                [disabled]="!isCustomTheme()"
                (checkedChange)="onDarkModeChange($event)"
                aria-label="Tema scuro"
              />
              <span
                class="text-sm"
                [class.text-muted-foreground]="!isCustomTheme()"
                [class.text-foreground]="isCustomTheme()"
              >
                Dark
              </span>
            </div>
          </div>
        </div>
      </o2-accordion-item>

      <!-- Password Accordion -->
      <o2-accordion-item label="Password">
        <div class="p-5 pt-2">
          <form [formGroup]="passwordForm" class="flex flex-col gap-3.5">
            <!-- Vecchia Password -->
            <div class="flex items-start gap-4">
              <label hlmLabel for="oldPassword" class="w-1/4 sheet-label pt-2"
                >Vecchia password</label
              >
              <hlm-form-field class="w-3/4">
                <o2-password-input
                  id="oldPassword"
                  formControlName="oldPassword"
                  placeholder="Inserisci vecchia password"
                />
                <hlm-error>La vecchia password è obbligatoria</hlm-error>
              </hlm-form-field>
            </div>

            <!-- Nuova Password -->
            <div class="flex items-start gap-4">
              <label hlmLabel for="newPassword" class="w-1/4 sheet-label pt-2"
                >Nuova password</label
              >
              <div class="w-3/4 flex flex-col gap-2">
                <hlm-form-field>
                  <o2-password-input
                    id="newPassword"
                    formControlName="newPassword"
                    placeholder="Inserisci nuova password"
                  />
                  <hlm-error
                    >La nuova password deve essere diversa dalla
                    vecchia</hlm-error
                  >
                </hlm-form-field>
                <div
                  [class.text-destructive]="
                    passwordForm.controls.newPassword.invalid &&
                    passwordForm.controls.newPassword.touched
                  "
                  [class.text-muted-foreground]="
                    !passwordForm.controls.newPassword.touched ||
                    passwordForm.controls.newPassword.valid
                  "
                  class="text-xs"
                >
                  La password deve contenere:
                  <ul class="list-disc list-inside mt-1">
                    <li>8 caratteri</li>
                    <li>1 carattere speciale (&#64;$!%*?&)</li>
                    <li>1 numero</li>
                    <li>1 lettera maiuscola</li>
                    <li>1 lettera minuscola</li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Conferma Password -->
            <div class="flex items-start gap-4">
              <label
                hlmLabel
                for="confirmPassword"
                class="w-1/4 sheet-label pt-2"
                >Conferma password</label
              >
              <hlm-form-field class="w-3/4">
                <o2-password-input
                  id="confirmPassword"
                  formControlName="confirmPassword"
                  placeholder="Conferma nuova password"
                />
                <hlm-error>Le password non corrispondono</hlm-error>
              </hlm-form-field>
            </div>

            <!-- Error Message -->
            @if (hasError()) {
              <div class="flex items-start gap-4">
                <div class="w-1/4"></div>
                <div class="w-3/4">
                  <p class="text-sm text-destructive">
                    {{ errorMessage() }}
                  </p>
                </div>
              </div>
            }
          </form>
        </div>
      </o2-accordion-item>
    </o2-accordion-group>
  </div>

  <div o2SheetFooter>
    <button type="button" hlmBtn variant="outline" (click)="close()">
      Annulla
    </button>
    <button
      type="button"
      hlmBtn
      variant="default"
      (click)="save()"
      [disabled]="isSaveDisabled()"
    >
      Salva
    </button>
  </div>
</o2-sheet>
